<template>
  <div
    v-if="enableNameField"
    class="row">
    <div class="col">
      <div class="form-group">
        <label>{{ labels.name }}</label>
        <input
          v-validate="getValidationRules()"
          v-model="address.name"
          :name="`${name}-name`"
          :class="{ 'is-invalid': errors.has(`${name}-name`) }"
          :data-vv-as="labels.name"
          data-test="name"
          class="form-control"
          type="text"
          @input="input"
          @blur="blur"
        >
        <div
          v-if="errors.has(`${name}-name`)"
          class="invalid-feedback">
          {{ errors.first(`${name}-name`) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  inject: ['$validator'],
  props: {
    enableNameField: {
      type: Boolean,
      default: true
    },
    address: {
      type: Object,
      default: Object
    },
    labels: {
      type: Object,
      default: Object
    },
    name: {
      type: String,
      required: true
    },
    addressConfig: {
      type: Object,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    nameFieldRequired: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters(['consumerInfo', 'consumerBillingAddress'])
  },

  methods: {
    input () {
      this.$emit('input')
    },
    blur () {
      this.$emit('blur')
    },
    getValidationRules () {
      if (this.nameFieldRequired) {
        return { required: true, max: 100 }
      } else {
        return {}
      }
    }
  }
}
</script>
